import React from 'react';
import InfoTooltip from 'components/shared/InfoTooltip';
import LabsBadge from 'components/shared/LabsBadge';

const DataCardTitle = ({ title, tooltip, subtitle, labsBadgeDescription }) => (
  <h3 className="DataCard-title">
    {title}
    {labsBadgeDescription && (
      <LabsBadge dark className="d-ib ml-8">
        <p>{labsBadgeDescription}</p>
        <LabsBadge.FeedbackMessage />
      </LabsBadge>
    )}
    {tooltip && <InfoTooltip tooltip={tooltip} className="ml-4" />}
    {subtitle && <span className="DataCard-subtitle">{subtitle}</span>}
  </h3>
);

export default DataCardTitle;
